import React from 'react';
import styled from 'styled-components';
import { InputAdornment, TextField } from '@mui/material';
import { SearchRounded } from '@mui/icons-material';
import useStudentsCourseLAB from '../../../../hooks/teacher/useStudentsCourseLAB';
import SimpleLoading from '../../../common/SimpleLoading';
import ErrorResponse from '../../../common/ErrorResponse';
import UsersCardLAB from './student/UsersCardLAB';

const StudentsLAB = ({ id }) => {
    const { students, searchQuery, setSearchQuery } = useStudentsCourseLAB(id);

    if (students === null) {
        return <SimpleLoading />;
    }

    if (students === false) {
        return (
            <Container>
                <ErrorResponse message="Error al cargar estudiantes LAB" />
            </Container>
        );
    }

    return (
        <Container>
            <Header>
                <TextField
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    variant="outlined"
                    size="small"
                    label="Buscar estudiante LAB..."
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchRounded />
                            </InputAdornment>
                        ),
                    }}
                />
            </Header>

            {students.length === 0 ? (
                <ErrorResponse message="No hay estudiantes LAB en esta asignatura" />
            ) : (
                <UsersWrapper>
                    {students.map((user, index) => (
                        <UsersCardLAB
                            key={user.id || `student-${index}`}
                            user={user}
                        />
                    ))}
                </UsersWrapper>
            )}
        </Container>
    );
};

export default StudentsLAB;

const Container = styled.div`
    width: calc(100% - 32px);
    min-height: 70vh;
    margin: 0 auto;
    padding: 0 16px;
`;

const Header = styled.div`
    display: flex;
    padding: 16px;
    gap: 1rem;
    position: relative;
`;

const UsersWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(343px, 1fr));
    gap: 1rem;
    justify-content: center;
    margin-bottom: 1rem;
    padding: 1rem;
    align-items: start;
`;
